<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ValidierungsFehler",
  components: {},
  props: {
    fehlerText: String,
    reduzierterAbstand: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return props;
  },
});
</script>

<template>
  <div
    v-if="fehlerText"
    class="gevng-form-validation__error-container"
    :class="{
      'gevng-form-validation__error-container-reduziert': reduzierterAbstand,
    }"
    role="alert"
    aria-label="Fehlerhafte Eingabe"
    :aria-live="fehlerText ? 'assertive' : 'off'"
  >
    {{ fehlerText }}
  </div>
</template>
